(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('projectProcess', {
        templateUrl: 'views/components/views/projectProcess/projectProcess.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            'stateService',
            'projectProcessService',
            'translateService',
            'modalService',
            function ($stateParams, stateService, projectProcessService, translateService, modalService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;
                let projectKeyno = $stateParams.project_keyno;
                let projectProsessKeyno = $stateParams.projectprosess_keyno;

                vm.model = {
                    projectProsessKeyno: projectProsessKeyno,
                    edit: {},
                    selectListPriceMethods: [],
                    lockedSave: false,
                    lockedDelete: false,
                };

                let translations = { ok: '', error: '' };

                // #endregion VARIABLES & DEFINITIONS

                // #region LOAD PROCEDURE FUNCTION CALLS

                let loadEdit = function () {
                    projectProcessService
                        .getEdit({
                            project_keyno: projectKeyno,
                            projectprosess_keyno: projectProsessKeyno,
                        })
                        .then(function (info) {
                            angular.copy(info[0], vm.model.edit);
                        });
                };

                let loadPriceMethods = function () {
                    projectProcessService.listPriceMethods().then(function (list) {
                        angular.copy(list, vm.model.selectListPriceMethods);
                    });
                };

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region SAVE BUTTON FUNCTION

                vm.saveChanges = async function () {
                    vm.model.lockedSave = true;

                    try {
                        const { errorcode, errormessage } = await projectProcessService.saveObj(vm.model.edit);
                        if ('' + errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                        },
                                    },
                                ],
                            });
                        } else {
                            stateService.back();
                        }
                    } catch (error) {
                        console.error(error);
                    } finally {
                        vm.model.lockedSave = false;
                    }
                };

                // #endregion SAVE BUTTON FUNCTION

                // #region DELETE BUTTON FUNCTION

                vm.deleteValues = async function () {
                    vm.model.lockedDelete = true;

                    try {
                        const { errorcode, errormessage } = await projectProcessService.deleteItem(vm.model.edit);

                        if ('' + errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                        },
                                    },
                                ],
                            });
                        } else {
                            stateService.back();
                        }
                    } finally {
                        vm.model.lockedDelete = false;
                    }
                };

                async function translate() {
                    translations = await translateService.translateBatch(translations);
                }

                // #endregion DELETE BUTTON FUNCTION

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    translate();
                    loadEdit();
                    loadPriceMethods();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
